import * as React from 'react';
import { Route, Routes, CompatRouter, } from "react-router-dom-v5-compat";
import { BrowserRouter, } from 'react-router-dom'

import DiagnosticInsights from '../components/progress_reports/diagnostic_insights/index'

const DiagnosticInsightsRouter = (props) => (
  <BrowserRouter>
    <CompatRouter>
      <Routes>
        <Route element={<DiagnosticInsights {...props} />} path="/teachers/progress_reports/diagnostic_insights/*" />
      </Routes>
    </CompatRouter>
  </BrowserRouter>
)

export default DiagnosticInsightsRouter
